import React, { useRef, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import ViewAlertDevice from './alert/ViewAlertDevice';
import EditAlertDevice from './alert/EditAlertDevice';
import { getSiteInfo } from '../../redux/actions/systemActions';

/**
 * The function to display the appropriate components for users.
 * @description - React Router takes the url paths and displays the appropriate components. If the route is /users/ it will display the list of users. If the Route is /users/ followed by a number, it will display the full view of that user. If it's /users/edit/ followed by a number, it will display the edit view for that user
 */

export function UnconnectedDevices(props) {
  const location = useLocation();
  const previousLocation = useRef(location);

  if (
    location &&
    location.state &&
    location.state.modal &&
    window.history.state && window.history.state.idx > 0 // Check if we navigated back
  ) {
    if (location.pathname === '/devices/alert/:id/edit/') {
      previousLocation.current = { pathname: '/users/' };
    }
  }

  useEffect(() => {
    props.dispatch(getSiteInfo());
  }, []); // eslint-disable-line

  useEffect(() => {
    if (location) {
      if (location.state && location.state.modal) {
        previousLocation.current = { pathname: '/devices/' };
      } else {
        previousLocation.current = location;
      }
    }
  }, [location]);

  return (
    <React.Fragment>
      <Routes>
        {/* <Route path="/devices/" element={<UserList />} /> */}
        <Route
          path="/alert/:id/view"
          element={<ViewAlertDevice />}
          data-test="view-alert-device"
        />
        <Route
          path="/alert/:id/edit"
          element={<EditAlertDevice />}
          data-test="edit-alert-device"
        />
      </Routes>
    </React.Fragment>
  );
}
export const DevicesWithRouter = connect()(UnconnectedDevices);
export default connect()(UnconnectedDevices);
